// eslint-disable-next-line import/prefer-default-export
export const BASE_ES = {
  // Filters
  OthersFilters: 'Otros filtros',
  AvailableFilters: 'Filtros disponibles',
  KeyWords: 'Nombre:',
  placeholderNameApplicant: 'Nombre del postulante',
  placeholderNameVacancy: 'Por vacante:',
  Search: 'Buscar',
  AddFilter: 'Agregar filtros',
  optionFilter: 'Otras funciones',
  Basics: 'Básicos',
  ByStars: 'Por estrellas:',
  Stars: 'Estrellas',
  ApplicantsState: 'Estado del postulante:',
  ByDate: 'Por fecha:',
  OrderBy: 'Ordenar por:',
  Newer: 'Más reciente',
  Older: 'Más antiguo',
  Institutes: 'Institutos',
  OnlySavedApplicants: 'Guardados',
  clear: 'Limpiar',
  apply: 'Aplicar',

  // data
  Results: 'Resultados',
  VacancyName: 'Nombre vacante',
  Score: 'Calificación',
  Status: 'Estado',
  Date: 'Fecha',
  NoData: 'No hay datos, intenta cambiar las fechas',
  NoDataNoJob: 'En esta sección podrás ver a todos los candidatos que se habrán postulado a tus vacantes.',
  All: 'Todos',
  Pending: 'Pendiente',
  InProcess: 'En proceso',
  Accepted: 'Aceptado',
  Rejected: 'Rechazado',
  Selected: 'Seleccionados',
  AddToVacancy: 'Agregar a vacante',
  SendEmail: 'Enviar correo',

  // modalAddCandidate
  AddCandidate: 'Agregar candidato',
  exportPDF: 'Exportar a PDF',
  exportExcel: 'Exportar a Excel',
  ExportCandidates: 'Exportar candidatos',
  ImportCandidates: 'Importar candidatos',
  NewCandidate: 'Nuevo candidato',
  placeholderFirstName: 'Nombre',
  placeholderLastName: 'Apellidos',
  placeholderEmail: 'Correo',
  placeholderPhone: 'Teléfono',
  SelectCv: 'Seleccione un cv (Opcional)',
  GeneratedId1: 'Hemos generado el ID: ',
  AddPhoneSecondary: 'Número secundario',
  AddEmailSecondary: 'Correo secundario',
  GeneratedId2: ' para su archivo',
  placeholderTextArea: 'Escriba algo sobre el candidato',
  reloadPage: 'Acción requerida: Recarga la página para visualizar este candidato.',
  Add: 'Agregar',

  // modalImportCandidate
  Instructions: 'Instrucciones',
  placeholderSelectVacancy: 'Seleccione una vacante',
  ImportHeader: 'Importar Candidatos',
  ImportExcell: 'Importar Excel',
  SelectVacancy: 'Seleccione la vacante a la que el candidato será agregado:',
  CandidateFirstName: 'Nombre:',
  CandidateLastName: 'Apellidos:',
  CandidateEmail: 'Correo:',
  CandidatePhone: 'Teléfono:',
  Cv: 'CV:',
  Accept: 'Aceptar',

  // modalInvitation
  inviteHeader: 'Invitar a candidato',
  invitationMessage: '¿Qué correo de invitación desea enviar a ',
  template: 'Plantilla',
  customize: 'Personalizar',

  // modalCustomInvitationEmail
  CustomInvitationHeader: 'Personalizar correo de invitación',
  example: 'Ejemplo',
  textExample: 'Hola {Candidate}, es un gusto saludarte.',
  preview: 'Vista previa',
  textPreview: 'Hola Carlos Antonio Méndez, es un gusto saludarte.',
  importantInfo: 'Datos importantes',
  company: 'Empresa',
  vacancy: 'Vacante',
  candidate: 'Candidato',
  send: 'Enviar',
  placeholder: 'Escriba algo',
  whichMail: '¿Qué correo quiere enviar al candidato?',
  customizeMail: 'Personalizar correo',

  // Instructions
  Instruction1: 'Suba un archivo Excell con la información de los candidatos.',
  Instruction2: 'Elegir la vacante a la cual se cargarán los candidatos. ',
  Instruction3:
    'En caso de dejar vacío el campo, se cargarán los candidatos y solo se visualizaran en base de candidatos.',
  Instruction4:
    'Elegir los encabezados de su excel que contiene la información requerida para cada uno de los campos. ',
  Instruction5: 'En caso de dejar vacío el campo, se guardaran los candidatos sin dicho dato. ',

  // Candidate details
  ApplicantDetails: 'Detalles del postulante',
  AddedBy: 'Agregado por ',
  On: 'el ',

  // Table
  candidateName: 'Nombre del candidato',
  vacancyName: 'Nombre de la vacante',
  score: 'Calificación',
  status: 'Estatus',
  date: 'Fecha',
  actions: 'Acciones',
  select: 'Seleccionar',
  lastNames: 'Apellidos del candidato',
  addBaseCandidates: 'Agregado desde Base de candidatos',

  // Asignar
  titleAsignar: '¿A qué vacantes registramos los candidatos?',
  cancel: 'Cancelar',
  transfer: 'Transferir',
  invite: 'Invitar',
  register: 'Registrando...',
  // Export Titles
  numberEmpty: 'Sin número telefónico',
  emailEmpty: 'Sin email',
  Average: 'Promedio',
  AverageEmpty: 'No tiene cuestionario',
  cvEmpty: 'Sin cv',
  Unrated: 'Sin calificar',
  FirstName: 'Nombres',
  LastName: 'Apellidos',
  Email: 'Email',
  EmailSecondary: 'Email secundario',
  Qualification: 'Calificación',
  PhoneNumber: 'Número telefónico',
  SecondaryNumber: 'Número secundario',
  DescriptionEmpty: 'Sin descripción',
  Description: 'Descripción',
  cvWithBias: 'Cv con sesgos',
  cvWithoutBias: 'Cv sin sesgos',
  Comments: 'Comentarios',
  CommentsEmpty: 'Sin comentarios',
};
